import { Button } from "@mui/material";
import QuestionElement from "./QuestionElement";

const QuestionCard = ({questions,color}) => {

    return (
    <>
        {
            questions && questions?.map((q,i)=>(
                <QuestionElement key={i} text={q.text} qId={q._id}/>
            ))
        }
        <Button variant="contained" sx={{color:`${color}`,backgroundColor:"white",marginTop:"20px"}}>Add question</Button>
    </>
    )
}

export default QuestionCard